module.exports = __webpack_public_path__ + "img/Comic05-3.8b07d8d7.png";